document.addEventListener("DOMContentLoaded", function() {

	var $ = jQuery.noConflict(),
		home_url = window.location.hostname,
		d = new Date(),
		n = d.getFullYear(),
		page = $('html, body');

	$('.scroll-up').click(function(event) {
		page.animate({
			scrollTop : 0,
		}, 100);
		event.preventDefault();
	});

	// Parallax for LG (responsive large tablet & up)
	var win = $(window);

	if (win.width() > 992) {

		new Rellax('.section_fsd .wp-block-image, .section_trade-range .door-right-top, .section_signature .wp-block-media-text__media', {
			speed: -1.35,
			center: false,
			wrapper: null,
			round: true,
			vertical: true,
			horizontal: false
		});

		new Rellax('.wp-block-media-text__content figure, .section_fsd .wp-block-video, .page-id-633 .section_why-next-gen .wp-block-media-text__media, .page-id-737 .section_why-next-gen .wp-block-media-text__media, .page-id-738 .section_why-next-gen .wp-block-media-text__media', {
			speed: 0.65,
			center: false,
			wrapper: null,
			round: true,
			vertical: true,
			horizontal: false
		});

		new Rellax('.section_stunning-aesthetics .col-lg-3 .wp-block-image, .kid-box-img, .section_premium .col-lg-3 .wp-block-image, .kid-box-img', {
			speed: -1,
			center: false,
			wrapper: null,
			round: true,
			vertical: true,
			horizontal: false
		});

		new Rellax('.section_stunning-aesthetics .col-lg-5 .wp-block-image, .section_enhanced-security .family-kitchen, .section_premium .col .wp-block-image.composite-door-img', {
			speed: 1,
			center: false,
			wrapper: null,
			round: true,
			vertical: true,
			horizontal: false
		});

		new Rellax('.section_enhanced-security .wp-block-video', {
			speed: 0.02,
			center: false,
			wrapper: null,
			round: true,
			vertical: true,
			horizontal: false
		});

		new Rellax('.section_product-range .wp-block-media-text-certified, .section_trade-range .door-left-top, .section_helping-customers .door-left-top .wp-block-image, .section_our-services .wp-block-media-text__media', {
			speed: -0.75,
			center: false,
			wrapper: null,
			round: true,
			vertical: true,
			horizontal: false
		});

		new Rellax('.paint_grey, .paint_yellow', {
			speed: -2,
			center: false,
			wrapper: null,
			round: true,
			vertical: true,
			horizontal: false
		});
	}

	$('.home .doorvideo video').attr({'loop':'','playsinline':''});

	function onScroll() {

		if ($(window).scrollTop() > 70) {
			$('.scroll-up').removeClass('hidden');
		} else {
			$('.scroll-up').addClass('hidden');
		}

		/* Check the location of each desired element */
		$(".animated-section").each( function(i) {
			var bottom_of_object = $(this).offset().top + $(this).outerHeight() + 100;
			var bottom_of_window = $(window).scrollTop() + $(window).height() + $(this).outerHeight() + 100;
			/* If the object is completely visible in the window, fade it it */
			if (bottom_of_window > bottom_of_object) {
				$(this).addClass("go");
				$('.home .doorvideo video').trigger('click');
			} else {
				$(this).removeClass("go", 200);
			}
		});
	}
	window.addEventListener('scroll', onScroll, false);

	/**
	* Menu Scroll
	*/
	var lastScrollTop = 0;
	$(window).scroll(function(event) {    
		var scroll = $(window).scrollTop();
		var HeroHeader = $('.hero-header .container .row:first-child');
		var PageHeader = $('.page-header .container .row:first-child');
	
		if (scroll >= 100) {
			$(HeroHeader).addClass("onScroll");
			$(PageHeader).addClass("onScroll");
		} else {
			$(HeroHeader).removeClass("onScroll");
			$(PageHeader).removeClass("onScroll");
		}

		if ( scroll < 150 || scroll == 0 ) {
			$('.page-header.col-12 + .col').css('z-index','auto');
			$('.section_team, #paint-brush').removeAttr('style');
		}

		var st = $(this).scrollTop();
		if (st > lastScrollTop) {
			$(HeroHeader).removeClass("onScrollUp");
			$(PageHeader).removeClass("onScrollUp");
		} else {
			if (scroll >= 150) {
				$('.page-header.col-12 + .col').css('z-index','0');
				$('.section_team, #paint-brush').css({'opacity':'0','margin':'0','height':'0','display':'none'});
			}
			$(HeroHeader).addClass("onScrollUp");
			$(PageHeader).addClass("onScrollUp");
		}
		lastScrollTop = st;
	});


	$('.wpcf7-select').select2({
		placeholder: "Please select",
    	allowClear: true
	});

	$('.page-template-page-products-single.page-id-633 .breadcrumb_last').text('nxt-gen');
	$('.page-template-page-products-single.page-id-737 .breadcrumb_last').text('Signature');
	$('.page-template-page-products-single.page-id-738 .breadcrumb_last').text('Contemporary');
	$('.page-template-page-products-single.page-id-805 .breadcrumb_last').text('Fire');
	$('.sl-form-group h4').text('Enter your address');

	// Custom Yoast SEO Breadcrumb for single posts only
	$('body.single .breadcrumb > span > i:first-of-type')
		.after( "<span><a href='/inspiration'>Inspiration</a> </span><i></i>" );
		// .parent()
		// .addClass('archive-insp');


	// Ptroducts filter
	$('.section_find-door .row .col .wp-block-cover__inner-container p a em').wrapInner('<span></span>');

	$('.wp-block-navigation__responsive-container-content').prepend('<a href="https://'+home_url+'" id="logo-mob-home"></a>');

	$('.posts-filter--nav i, .signature-filter--selected-cat i').each( function() {
		$(this).on( 'click', function() {
			var name = $(this).attr('content-name');
			var txt = $(this).text();
			//console.log(name);
			$('.posts-filter--title').text(txt);
			$('.posts-filter--nav i').removeClass('active');
			$('.posts-filter_content-wrap>div').removeClass('active').hide();
			setTimeout(function() {
				$('.'+name).addClass('active').show();
			}, 200);
		});
	});

	// Inspiration # on load click nav tab
	if ( $('body').hasClass('page-id-1391') ) {
		var location = document.URL.substr(document.URL.indexOf('#')+1).toLowerCase();
		//console.log(location);
		setTimeout(function() {
			$('.' + location).click();
		}, 500);
	}

	$(".signature-filter--select, .contemporary-filter--select").on("mouseover", function () {
		$(this).addClass('active');
	});

	$(".signature-filter--select, .contemporary-filter--select").on('mouseleave', function() {
		$(this).removeClass('active');
	});

	$(".signature-filter--select, .contemporary-filter--select").on('hover', function() {
		$(this).removeClass('active');
	});

	$('.signature-filter--select i, .signature-filter--selected-cat i, .contemporary-filter--select i, .contemporary-filter--selected-cat i').each( function() {
		$(this).on( 'click', function() {
			var name = $(this).attr('content-name');
			$('.signature-filter--select, .contemporary-filter--select, .signature-filter--select i.all, .contemporary-filter--select i.all').removeClass('active');
			$('.loadMoreBtn').hide();
			setTimeout(function() {
				$('.'+name).toggleClass('active');
				setTimeout(function() {
					$('.section_find-door .row.doors-filter .col').fadeOut();
					setTimeout(function() {
						$('.section_find-door .row.doors-filter .col.active').fadeIn(200);
						setTimeout(function() {
							$('.filter-by').click();
							var count = $('.section_find-door .row.doors-filter .col.active').length;
							//console.log(count);
							if ( count <= 0 ) {
								setTimeout(function() {
									$('.signature-filter--select i, .signature-filter--selected-cat i, .signature-filter--check').removeClass('active');
									setTimeout(function() {
										$('.section_find-door .row.doors-filter .col').filter('.col:lt(8)').fadeIn(500);
									}, 500);
									$('.loadMoreBtn').removeAttr('style');
								}, 100);
							}
						}, 200);
					}, 100);
				}, 100);
			}, 200);
		});
	});

	$('.signature-filter--select i.all, .contemporary-filter--select i.all').on( 'click', function() {
		$('.signature-filter--select i, .signature-filter--selected-cat i, .signature-filter--check, .contemporary-filter--select i, .contemporary-filter--selected-cat i').removeClass('active');
		$('.stable, .signature-filter--check').removeClass('active');
		$('.section_find-door .row.doors-filter .col.stable').hide();
		setTimeout(function() {
			$('.section_find-door .row.doors-filter .col').filter('.col:lt(8)').fadeIn(500);
		}, 700);
		$('.loadMoreBtn').removeAttr('style');
		$(this).addClass('active');
	});

	$('.signature-filter--check div').on( 'click', function() {
		$('.loadMoreBtn').removeClass('active').hide();
		$(this).parent().toggleClass('active');
		setTimeout(function() {
			//$('.stable').removeClass('active');
			$('.section_find-door .row.doors-filter .col.stable').toggle();
		}, 500);
	});

	$('.tooltip-info').on( 'click', function() {
		$(this).toggleClass('active');
	});

	$('.stable').on( 'click', function() {
		$('.signature-filter--check').removeClass('active');
	});

	$('.section_tabs-colours .nav-tabs a').each( function() {
		var tab = $(this).attr('id');
		$(this).on( 'click', function() {
			$('.section_whats-colour picture').addClass('hidden');
			$('.section_whats-colour picture.'+ tab).removeClass('hidden');
		});
	});

	// --- ScrollMagic & GSAP Animations --- //

	var controller0 = new ScrollMagic.Controller();

	var tl0 = new TimelineMax();
	tl0.fromTo(".numbers-list-scroll li:nth-child(1)",1,{ opacity: 1 },{ opacity: 1, ease: Linear.easeNone },"+=1");
	tl0.fromTo(".numbers-list-scroll li:nth-child(1)",1,{ opacity: 0 },{ opacity: 1, ease: Linear.easeNone },"+=1");
	tl0.fromTo(".numbers-list-scroll li:nth-child(1)",1,{ opacity: 1 },{ opacity: 0, ease: Linear.easeNone },"+=1");
	tl0.fromTo(".numbers-list-scroll li:nth-child(2)",1,{ opacity: 0 },{ opacity: 1, ease: Linear.easeNone },"+=1");
	tl0.fromTo(".numbers-list-scroll li:nth-child(2)",1,{ opacity: 1 },{ opacity: 0, ease: Linear.easeNone },"+=1");
	tl0.fromTo(".numbers-list-scroll li:nth-child(3)",1,{ opacity: 0 },{ opacity: 1, ease: Linear.easeNone },"+=1");
	tl0.fromTo(".numbers-list-scroll li:nth-child(3)",1,{ opacity: 1 },{ opacity: 0, ease: Linear.easeNone },"+=1");
	tl0.fromTo(".numbers-list-scroll li:nth-child(4)",1,{ opacity: 0 },{ opacity: 1, ease: Linear.easeNone },"+=1");
	tl0.fromTo(".numbers-list-scroll li:nth-child(4)",1,{ opacity: 1 },{ opacity: 0, ease: Linear.easeNone },"+=1");
	tl0.fromTo(".numbers-list-scroll li",1,{ opacity: 0 },{ opacity: 0, ease: Linear.easeNone },"+=1");
	tl0.fromTo(".numbers-list-scroll li:nth-child(1)",1,{ opacity: 1 },{ opacity: 1, ease: Linear.easeNone },"+=1");

	new ScrollMagic.Scene({
		triggerElement: "#pinMasterIntro",
		triggerHook: "onLeave",
		duration: "500"
	})
	.setPin("#pinMasterIntro")
	.setTween(tl0)
	//.addIndicators()
	.addTo(controller0);

	if (win.width() > 576) {

		var controller = new ScrollMagic.Controller();

		var tl = new TimelineMax();
		tl.fromTo(".dynamic-txt-head",1,{ opacity: 0 },{ opacity: 1, className: "dynamic-txt-head why-door-fixed", ease: Linear.easeNone },"+=1");
		tl.fromTo("#why-door",1,{ },{ className: "why-door-fixed", ease: Linear.easeNone },"+=1");
		tl.fromTo("#why-door svg .line1, #why-door svg .line2, #why-door svg .line3, #why-door svg .line4, #why-door svg .line5, #why-door svg .line6, .dynamic-txt",1,{ opacity: 0 },{ opacity: 0, ease: Linear.easeNone },"+=1");
		tl.fromTo("#why-door svg .door1",1,{ opacity: 1 },{ opacity: 0, ease: Linear.easeNone },"+=1");
		tl.fromTo("#why-door svg .door2",1,{ opacity: 1 },{ opacity: 0, ease: Linear.easeNone },"+=1");
		//tl.fromTo(".dynamic-txt-head",1,{ opacity: 0 },{ opacity: 1, ease: Linear.easeNone },"+=1");
		tl.fromTo(".page-template-page-why-distinction .wp-site-blocks",1,{},{ className: "wp-site-blocks fixed", ease: Linear.easeNone },"+=1");
		tl.fromTo("#why-door svg .line1, .txt1",1,{ opacity: 0 },{ opacity: 1, ease: Linear.easeNone },"+=1");
		tl.fromTo("#why-door svg .line1, .txt1",1,{ opacity: 1 },{ opacity: 0, ease: Linear.easeNone },"+=1");
		tl.fromTo("#why-door svg .line2, .txt2",1,{ opacity: 0 },{ opacity: 1, ease: Linear.easeNone },"+=1");
		tl.fromTo("#why-door svg .line2, .txt2",1,{ opacity: 1 },{ opacity: 0, ease: Linear.easeNone },"+=1");
		tl.fromTo("#why-door svg .line3, .txt3",1,{ opacity: 0 },{ opacity: 1, ease: Linear.easeNone },"+=1");
		tl.fromTo("#why-door svg .line3, .txt3",1,{ opacity: 1 },{ opacity: 0, ease: Linear.easeNone },"+=1");
		tl.fromTo("#why-door svg .line4, .txt4",1,{ opacity: 0 },{ opacity: 1, ease: Linear.easeNone },"+=1");
		tl.fromTo("#why-door svg .line4, .txt4",1,{ opacity: 1 },{ opacity: 0, ease: Linear.easeNone },"+=1");
		tl.fromTo("#why-door svg .line5, .txt5",1,{ opacity: 0 },{ opacity: 1, ease: Linear.easeNone },"+=1");
		tl.fromTo("#why-door svg .line5, .txt5",1,{ opacity: 1 },{ opacity: 0, ease: Linear.easeNone },"+=1");
		tl.fromTo("#why-door svg .line6, .txt6",1,{ opacity: 0 },{ opacity: 1, ease: Linear.easeNone },"+=1");
		tl.fromTo("#why-door svg .line6, .dynamic-txt-head, .txt6",1,{ opacity: 1 },{ opacity: 0, ease: Linear.easeNone },"+=1");
		tl.fromTo(".page-template-page-why-distinction .wp-site-blocks",1,{},{ className: "wp-site-blocks", ease: Linear.easeNone },"+=1");
		tl.fromTo("#why-door svg .line1, #why-door svg .line2, #why-door svg .line3, #why-door svg .line4, #why-door svg .line5, #why-door svg .line6, .dynamic-txt",1,{ opacity: 0 },{ opacity: 0, ease: Linear.easeNone },"+=1");

		new ScrollMagic.Scene({
			triggerElement: "#pinMaster",
			triggerHook: "onLeave",
			duration: "200%"
		})
		.setPin("#pinMaster")
		.setTween(tl)
		//.addIndicators()
		.addTo(controller);
	} else {

		var n = 0;

		$('.section_innovation--mob-slider .wp-block-gallery .wp-block-image').each( function() {
			$(this).addClass( 't' + (n+1) ).prepend( "<div class='content'></div>" );
		});

		var t1 = $('.dynamic-txt.txt1').html();
		var t2 = $('.dynamic-txt.txt2').html();
		var t3 = $('.dynamic-txt.txt3').html();
		var t4 = $('.dynamic-txt.txt4').html();
		var t5 = $('.dynamic-txt.txt5').html();
		var t6 = $('.dynamic-txt.txt6').html();
		//console.log(t1);

		setTimeout(function () {
			$('.section_innovation--mob-slider .wp-block-gallery .wp-block-image.t1 .content').prepend(t1);
			$('.section_innovation--mob-slider .wp-block-gallery .wp-block-image.t2 .content').prepend(t2);
			$('.section_innovation--mob-slider .wp-block-gallery .wp-block-image.t3 .content').prepend(t3);
			$('.section_innovation--mob-slider .wp-block-gallery .wp-block-image.t4 .content').prepend(t4);
			$('.section_innovation--mob-slider .wp-block-gallery .wp-block-image.t5 .content').prepend(t5);
			$('.section_innovation--mob-slider .wp-block-gallery .wp-block-image.t6 .content').prepend(t6);
		}, 200);
	}

	// END --- ScrollMagic & GSAP Animations --- //

	// function getCookie(cname) {
	// 	var name = cname + "=";
	// 	var ca = document.cookie.split(';');
	// 	for (var i = 0; i < ca.length; i++) {
	// 		var c = ca[i];
	// 		while (c.charAt(0) == ' ') {
	// 		c = c.substring(1);
	// 		}
	// 		if (c.indexOf(name) == 0) {
	// 		return c.substring(name.length, c.length);
	// 		}
	// 	}
	// 	return "";
	// }

	function setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	$('.page-template-page-products').addClass('fixed-body');

	if (document.cookie.indexOf("OpenDoors=true") == -1) {
		document.cookie = "OpenDoors=true; max-age=1800"; // 31556952: seconds in a 0.5 hour

		$('#open-door').addClass('preloader');

		setTimeout(function () {
			$('#open-door').removeClass('preloader');
			$('.section_open-door-bg-img, .section_open-door-item').show();
		}, 1000);

		setTimeout(function () {
			$('#open-door').addClass('once-sesion');
		}, 1500);

		setTimeout(function () {
			$('.page-template-page-products').removeClass('fixed-body');
			setCookie( 'OpenDoors', 'closed', 0.0078333 ); // whole numbers = days * 70min

			setTimeout(function () {
				$('#open-door').addClass('open-door-zoom');

				setTimeout(function () {
					$('#open-door').addClass('transp');
				}, 1500);

			}, 500);

			setTimeout(function () {
				$('#open-door').hide();
			}, 5000);

		}, 4000);
	} else {
		$('#open-door, .section_open-door-item').hide();
	}

	$('.wp-social-link-twitter a').html('<svg viewBox="0 0 24 24" aria-hidden="true" class="r-18jsvk2 r-4qtqp9 r-yyyyoo r-16y2uox r-8kz0gk r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-lrsllp"><g><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" fill="#45484b"></path></g></svg>');

	$('.scroll-down').click(function(e) {
		var SlideHeight = $('.hero-header').height();
		// /console.log(SlideHeight);
		page.animate({
			scrollTop : page.scrollTop() + SlideHeight,
		}, 200);
		e.preventDefault();
	});

});
